{
  "CYBUS_ADMIN_UI_BACKEND_HOST": {
    "path": [
      "backendHost"
    ],
    "schema": {
      "type": [
        "string",
        "null"
      ],
      "examples": [
        null
      ],
      "description": "The backend base url host. Defaults to the browser's host (location.host)",
      "minLength": 1
    }
  },
  "CYBUS_ADMIN_UI_CONTACT_SALES_EMAIL": {
    "path": [
      "contact",
      "salesEmail"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "sales@cybus.io"
      ],
      "description": "Cybus sales email",
      "format": "email"
    }
  },
  "CYBUS_ADMIN_UI_CONTACT_SUPPORT_EMAIL": {
    "path": [
      "contact",
      "supportEmail"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "support@cybus.io"
      ],
      "description": "Cybus support email",
      "format": "email"
    }
  },
  "CYBUS_ADMIN_UI_DISPLAY_VERSION": {
    "path": [
      "displayVersion"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "description": "The version of the application",
      "minLength": 1
    }
  },
  "CYBUS_ADMIN_UI_DOCUMENTATION": {
    "path": [
      "documentation"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "https://docs.cybus.io"
      ],
      "description": "The URL to Connectware documentation",
      "format": "uri"
    }
  },
  "CYBUS_ADMIN_UI_ENABLE_STORYBOOK": {
    "path": [
      "enableStorybook"
    ],
    "schema": {
      "type": [
        "boolean"
      ],
      "examples": [
        false
      ],
      "description": "Whether the internal component Storybook page is reachable. Meant for development/demo environments only"
    }
  },
  "CYBUS_ADMIN_UI_INFO_PAGE_REFRESH_RATE": {
    "path": [
      "infoPageRefreshRate"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        20000
      ],
      "description": "How often the info page will update (in milliseconds)",
      "minimum": 1,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_INTERACTION_THROTTLE": {
    "path": [
      "interactionThrottle"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        500
      ],
      "description": "How long user inactivity is required on service, resources and user management pages before executing a search/sort/page change (in milliseconds)",
      "minimum": 1,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_LICENSE_FILE_EXTENSION": {
    "path": [
      "licenseFileExtension"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "lic"
      ],
      "description": "The license file extension",
      "pattern": "^\\w+$",
      "minLength": 1
    }
  },
  "CYBUS_ADMIN_UI_LOGOUT_WARNING_PERIOD": {
    "path": [
      "logoutWarningPeriod"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "description": "How early users will be warned before being logged out",
      "minimum": 0
    }
  },
  "CYBUS_ADMIN_UI_MQTT_CYCLE": {
    "path": [
      "mqtt",
      "cycle"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        500
      ],
      "description": "The refresh rate in milliseconds of the mqtt clients",
      "minimum": 1,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_MQTT_MAX_TOPIC_DEPTH": {
    "path": [
      "mqtt",
      "maxTopicDepth"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        20
      ],
      "description": "The maximum topic depth the mqtt clients support",
      "minimum": 1
    }
  },
  "CYBUS_ADMIN_UI_MQTT_PATH": {
    "path": [
      "mqtt",
      "path"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "/mqtt"
      ],
      "description": "The path the mqtt clients will use to connect",
      "minLength": 1
    }
  },
  "CYBUS_ADMIN_UI_MQTT_TIMEOUT": {
    "path": [
      "mqtt",
      "timeout"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        6000
      ],
      "description": "The time the mqtt client will wait before throwing timeout errors (in milliseconds)",
      "minimum": 0,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_PAGE_SIZES_DEFAULT": {
    "path": [
      "pageSizes",
      "default"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        25
      ],
      "description": "Used when the table is the main part of the page being displayed",
      "minimum": 2,
      "maximum": 100
    }
  },
  "CYBUS_ADMIN_UI_PAGE_SIZES_LARGE": {
    "path": [
      "pageSizes",
      "large"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        50
      ],
      "description": "Offered between the default and the max size of a table",
      "minimum": 3,
      "maximum": 100
    }
  },
  "CYBUS_ADMIN_UI_PAGE_SIZES_MAX": {
    "path": [
      "pageSizes",
      "max"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        100
      ],
      "description": "Max size of a table",
      "minimum": 3,
      "maximum": 100
    }
  },
  "CYBUS_ADMIN_UI_PAGE_SIZES_SHORT": {
    "path": [
      "pageSizes",
      "short"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        10
      ],
      "description": "Used when the table is not the main part of the page being displayed",
      "minimum": 1,
      "maximum": 100
    }
  },
  "CYBUS_ADMIN_UI_RESOURCES_REFRESH_RATE": {
    "path": [
      "resourcesRefreshRate"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "description": "How often the page will wait before fetching results again (in milliseconds)",
      "minimum": 1,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_RESOURCES_REFRESH_THROTTLE": {
    "path": [
      "resourcesRefreshThrottle"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        5000
      ],
      "description": "Sets a limit to how often resources can be refreshed (in milliseconds)",
      "minimum": 0,
      "maximum": 60000
    }
  },
  "CYBUS_ADMIN_UI_RST_CACHE_LIFESPAN": {
    "path": [
      "rst",
      "cacheLifespan"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        500
      ],
      "description": "How long (in milliseconds) the data retrieved from the websockets can be used internally across the RSTAdapter",
      "minimum": 0,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_RST_MAX_PAGE_SIZE": {
    "path": [
      "rst",
      "maxPageSize"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        25
      ],
      "description": "The max page size supported on RST",
      "minimum": 1,
      "maximum": 100
    }
  },
  "CYBUS_ADMIN_UI_RST_RECONNECT_TIMEOUT": {
    "path": [
      "rst",
      "reconnectTimeout"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        5000
      ],
      "description": "How long Connectware should wait before it reconnects its sockets",
      "minimum": 0,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_SEARCH_MINIMUM": {
    "path": [
      "searchMinimum"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        3
      ],
      "description": "A search made below this threshold will not be used to load data onto the application in certain pages (EG Services, Endpoints, Mappings and ETC)",
      "minimum": 0
    }
  },
  "CYBUS_ADMIN_UI_SERVICES_COMMISSIONING_FILE_DOWNLOAD_MIME_TYPE": {
    "path": [
      "services",
      "commissioningFile",
      "downloadMimeType"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "text/yaml;charset=utf-8"
      ],
      "description": "The MIME type of the commissioning files",
      "minLength": 1
    }
  },
  "CYBUS_ADMIN_UI_SERVICES_COMMISSIONING_FILE_EXTENSIONS": {
    "path": [
      "services",
      "commissioningFile",
      "extensions"
    ],
    "schema": {
      "type": [
        "array"
      ],
      "items": {
        "type": [
          "string"
        ],
        "pattern": "^\\w+$"
      },
      "examples": [
        [
          "yml",
          "yaml"
        ]
      ],
      "description": "Supported commissioning file extensions",
      "minItems": 1
    }
  },
  "CYBUS_ADMIN_UI_SERVICES_EXTERNAL_URL_BASE_PATH": {
    "path": [
      "services",
      "externalUrlBasePath"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "/services"
      ],
      "description": "The path to external services",
      "minLength": 1
    }
  },
  "CYBUS_ADMIN_UI_USER_MANAGEMENT_CERTIFICATE_FILE_EXTENSION": {
    "path": [
      "userManagement",
      "certificateFileExtension"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "pem"
      ],
      "description": "Supported certificate file extension",
      "pattern": "^\\w+$",
      "minLength": 1
    }
  },
  "CYBUS_ADMIN_UI_USER_MANAGEMENT_CLIENT_REGISTRY_REFRESH_RATE": {
    "path": [
      "userManagement",
      "clientRegistryRefreshRate"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        5000
      ],
      "description": "How often the client registry should update (in milliseconds)",
      "minimum": 1,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_USER_MANAGEMENT_INDEXES_CACHE": {
    "path": [
      "userManagement",
      "indexesCache"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "description": "How long User Management's indexed results will be kept on the Admin UI (in milliseconds)",
      "minimum": 0,
      "maximum": 600000
    }
  },
  "CYBUS_ADMIN_UI_USER_MANAGEMENT_PAGE_SIZE": {
    "path": [
      "userManagement",
      "pageSize"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        20
      ],
      "description": "Page size on the user management tables (users, roles, permissions)",
      "minimum": 1,
      "maximum": 100
    }
  },
  "CYBUS_ADMIN_UI_USER_MANAGEMENT_PROTECTED_ROLES": {
    "path": [
      "userManagement",
      "protectedRoles"
    ],
    "schema": {
      "type": [
        "array"
      ],
      "items": {
        "type": [
          "string"
        ],
        "minLength": 1
      },
      "examples": [
        [
          "connectware-admin",
          "minimum-access",
          "protocol-mapper-agent"
        ]
      ],
      "description": "Roles that cannot be deleted or have their name edited"
    }
  },
  "CYBUS_ADMIN_UI_USER_MANAGEMENT_PROTECTED_USERS": {
    "path": [
      "userManagement",
      "protectedUsers"
    ],
    "schema": {
      "type": [
        "array"
      ],
      "items": {
        "type": [
          "string"
        ],
        "minLength": 1
      },
      "examples": [
        [
          "admin"
        ]
      ],
      "description": "Users that cannot be deleted or have their username edited"
    }
  },
  "CYBUS_ADMIN_UI_USER_MANAGEMENT_SEARCH_SIZE": {
    "path": [
      "userManagement",
      "searchSize"
    ],
    "schema": {
      "type": [
        "integer"
      ],
      "examples": [
        5
      ],
      "description": "Amount of items suggested when searching for a single user/permission/role",
      "minimum": 1,
      "maximum": 100
    }
  },
  "CYBUS_ADMIN_UI_WORKBENCH_PATH": {
    "path": [
      "workbenchPath"
    ],
    "schema": {
      "type": [
        "string"
      ],
      "examples": [
        "/workbench"
      ],
      "description": "Relative path to the external workbench",
      "minLength": 1
    }
  }
}